import React from 'react';
import { GiftIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { bonuses } from '../data/content';
export function Bonuses() {
  return <section className="w-full bg-brand-900 px-0 py-14 sm:px-6 sm:py-20" data-id="element-96" data-mp="plsky6ka14aa">
      <div className="mx-auto max-w-5xl px-4 sm:px-0" data-id="element-97" data-mp="aujwi0s41oyq">
        <p className="flex items-center justify-center gap-2 text-center text-[11.5px] font-extrabold uppercase tracking-[0.16em] text-gold" data-id="element-98" data-mp="ftmrstiaggti">
          <GiftIcon className="h-4 w-4" aria-hidden="true" data-id="element-99" data-mp="1su00gjdfzu3" />
          Exclusive bonuses — free today
        </p>
        <h2 className="mt-4 text-center font-display text-[26px] font-bold leading-tight text-white sm:text-4xl" data-id="element-100" data-mp="5tvwwqptfzsw">
          Plus, today you’ll get these{' '}
          <span className="text-gold" data-id="element-101" data-mp="3t1rakhuu1q6a">5 exclusive bonuses FREE</span>
        </h2>
        <p className="mt-4 text-center text-[15px] font-semibold text-brand-200" data-id="element-102" data-mp="1m9qjpljhtrmv">
          Total value: <span className="text-white" data-id="element-103" data-mp="1r9v0zds86qe5">$177</span> — included FREE
        </p>
      </div>

      <ul className="mx-auto mt-9 max-w-5xl space-y-6 sm:space-y-8" data-id="element-104" data-mp="3ie6gdcxu9ttk">
        {bonuses.map(bonus => <li key={bonus.number} className="overflow-hidden border-y border-white/10 bg-brand-800 sm:rounded-3xl sm:border" data-id="element-105" data-mp="3dflihk627m8a">
            <img src={bonus.image} alt={`${bonus.title} — ${bonus.number} mockup`} className="block w-full bg-white" width={1280} height={1280} data-id="element-106" data-mp="3r8ul91zi59hu" />

            <div className="p-5 sm:p-7" data-id="element-107" data-mp="2ugqzu03h61mu">
              <div className="flex flex-wrap items-center gap-2" data-id="element-108" data-mp="2uhsmz2xrmekx">
                <span className="rounded-lg bg-gold px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.1em] text-brand-900" data-id="element-109" data-mp="38gs1hhrkdd3d">
                  {bonus.number}
                </span>
                <span className="rounded-lg bg-white/10 px-2.5 py-1 text-[11px] font-extrabold uppercase tracking-[0.1em] text-white" data-id="element-110" data-mp="nprl7bkw0vmq">
                  Value: {bonus.value}
                </span>
              </div>
              <h3 className="mt-3.5 font-display text-[21px] font-bold uppercase leading-tight text-white sm:text-2xl" data-id="element-111" data-mp="3cjppd29wr0po">
                {bonus.title}
              </h3>
              <p className="mt-2.5 text-[14.5px] leading-relaxed text-brand-100" data-id="element-112" data-mp="3ljl6rou23ry5">{bonus.text}</p>
            </div>
          </li>)}
      </ul>

      <div className="mx-auto mt-11 max-w-xl px-4 sm:px-0" data-id="element-113" data-mp="3qhebedfpodwb">
        <CTAButton label="Get all 5 bonuses free" data-id="element-114" data-mp="2tsoryiofrd88" />
        <p className="mt-3 text-center text-[12.5px] font-medium text-brand-200" data-id="element-115" data-mp="2ttzxamxj4t1g">
          Included with your $27 one-time payment · Instant access
        </p>
      </div>
    </section>;
}